import styled from 'styled-components';

import { xdlColorBackground } from '@xing-com/tokens';

export const Background = styled.div`
  background: ${xdlColorBackground};
  min-height: 100vh;
  display: flex;
  justify-content: center;
`;

export const Container = styled.div`
  max-width: 80%;
  flex-direction: column;
  align-items: center;
  display: flex;
  justify-content: center;
  text-align: center;
`;
